export * from './PaperPlaneIcon';
